import { useTranslation } from 'react-i18next';

import ShellDockItem from '@/components/app-shell/ShellDockItem';
import { Dock } from '@/components/ui/daisy/dock';
import { useAppShell } from '@/data/context/AppShellContext';

export default function ShellDock() {
  const { navItems } = useAppShell();
  const { t } = useTranslation('translation', { keyPrefix: 'appShell.nav' });

  return (
    <Dock variant="floating" className="z-20" aria-label={t('label')}>
      {navItems.map(({ type, href, activePath, icon, labelKey }) => (
        <ShellDockItem
          key={type}
          href={href}
          activePath={activePath}
          icon={icon}
          label={t(labelKey)}
        />
      ))}
    </Dock>
  );
}
